// extracted by mini-css-extract-plugin
export default {"verifyAccount":"verifyAccount-GgHTy","verifyAccountFormTips":"verifyAccount-form-tips-icAhI","verifyAccountMobile":"verifyAccount-mobile-sR0Dt"};